import { takeLatest, put, call } from "redux-saga/effects";
import api from "../../../../network/apis/api";
import * as campaignSummaryActions from "../actions/account_campaign_summary_actions";
import * as campaignSummaryTypes from "../types/account_campaign_summary_types";
import { dispatchSnackbarError } from "../../../../utils/toaster";

function* getCampaignSummaryStatus(action) {
  try {
    const res = yield call(api.get, `/api/admin/campaign/account-summary/v2`, action.payload);
    if (res.status === 200) {
      yield put(campaignSummaryActions.getAccountCampaignSummarySuccess(res.data));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(campaignSummaryActions.getAccountCampaignSummaryFailure(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(campaignSummaryActions.getAccountCampaignSummaryFailure(e));
  }
}



export default function* campaignSummarySaga() {
  yield takeLatest(campaignSummaryTypes.getAccountCampaignSummary.GET_ACCOUNT_CAMPAIGN_SUMMARY_REQUEST, getCampaignSummaryStatus);
}
